"use client";

import { Square } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BatchCookingPricing() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const footnote = useRevealOnScroll<HTMLDivElement>();
  const tiers = [{
    label: "UNE SESSION À DOMICILE",
    description: "3 heures de batch cooking pour préparer plusieurs repas et alléger ta semaine.",
    price: "CHF 240",
    cta: "JE RÉSERVE MA SESSION"
  }, {
    label: "FORMULE 1 MOIS",
    description: "4 sessions de 3 heures, à raison d’un rendez-vous par semaine.",
    price: "CHF 860",
    cta: "JE CHOISIS LA FORMULE"
  }, {
    label: "BON CADEAU",
    description: "Offrir des repas, du temps et un peu de douceur pendant le postpartum.",
    price: "DÈS 240CHF",
    cta: "J’OFFRE UN BON CADEAU"
  }];
  return <section data-section-id="1637" id="batchcookingpricing" className="relative bg-[#F8F4ED] text-[#43362F] py-24 md:py-36 overflow-hidden">
      <div className="relative mx-auto max-w-[1360px] px-[clamp(1rem,4vw,3rem)]">
        <div ref={header.ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 transition-all duration-[520ms] ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
      }}>
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="font-serif text-xs font-semibold tracking-[0.18em] uppercase text-[#43362F]/70">
                Tarifs & Formules
              </span>
              <Square className="size-2 fill-[#A77B62] text-[#A77B62]" aria-hidden="true" />
              <span className="font-serif text-xs font-semibold tracking-[0.18em] uppercase text-[#43362F]/70">
                Batch Cooking
              </span>
            </div>
            <h2 className="font-serif font-extrabold leading-[1.2] tracking-tight text-[#43362F]" style={{
            fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)"
          }}>
              <span className="!font-semibold">Des repas <span className="!text-[rgba(134,78,14,1)]">simples, réconfortants et pensés</span> pour ton postpartum.</span>
            </h2>
          </div>
        </div>

        <div ref={grid.ref} className={`mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 transition-all duration-[520ms] delay-100 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
      }}>
          {tiers.map((tier, i) => <div data-index={i} key={i} className="group relative bg-[#FCFAF7] text-[#43362F] border border-[#D5C3B1]/40 transition-all duration-[220ms] rounded-lg text-center shadow-sm" style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)",
          boxShadow: "0 1px 2px rgba(67,54,47,0.05)"
        }}>
              <div className="p-10 md:p-12 flex flex-col h-full items-center">
                <div className="font-serif text-sm font-medium text-[#43362F]/70 mb-6 uppercase tracking-wider">
                  {tier.label}
                </div>

                <div className="flex items-baseline justify-center gap-3 mb-3">
                  <span className="font-serif font-extrabold uppercase leading-none tracking-tight text-[#43362F]" style={{
                fontSize: "clamp(2rem, 3vw, 2.75rem)"
              }}>
                    {tier.price}
                  </span>
                </div>

                <p className="text-sm text-[#43362F]/70 mb-8 leading-relaxed">
                  {tier.description}
                </p>

                <Button asChild className="w-full font-serif font-medium bg-[#A77B62] text-[#F8F4ED] hover:bg-[#A77B62]/90 rounded-lg h-auto px-7 py-4 border-0 mt-auto shadow-sm">
                  <Link to="/ContactPage">{tier.cta}</Link>
                </Button>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center max-w-2xl mx-auto">
          <p className="text-[#43362F]/60 text-sm font-default italic leading-relaxed">
            Les ingrédients ne sont pas compris. Les courses peuvent être organisées sur demande. Déplacement inclus dans la région de Nyon, avec un éventuel supplément au-delà.
          </p>
        </div>

        <div ref={footnote.ref} className={`mt-12 md:mt-16 transition-all duration-[520ms] delay-200 ${footnote.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
      }}>
          <p className="font-default text-sm text-[#43362F]/80 flex items-start gap-2 flex-wrap justify-center">
            <Square className="size-2 fill-[#A77B62] text-[#A77B62] shrink-0 mt-1.5" aria-hidden="true" />
            <span>Toutes les formules incluent : menu personnalisé et liste de courses.</span>
          </p>
        </div>
      </div>
    </section>;
}